module.exports = __webpack_public_path__ + "static/media/dumy-recent-news-2.ea814eec.png";